<template>
  <div class="portal-app-page">
    <RetailerHeader />
    <main class="portal-main portal-container legal-page">
    <PortalPageHeader eyebrow="Partner policy" title="Retail sales & pricing acknowledgment" description="The standards that protect UCARI customers, partners, and the value of the brand." />
    <article class="uk-card uk-card-default uk-card-body legal-card">

      <p class="uk-text-small uk-text-muted uk-margin-small-top">
        Last updated: {{ lastUpdated }}
      </p>

      <p class="uk-margin-medium-top">
        By purchasing UCARI products for resale, you acknowledge and agree to the following terms and conditions.
        These terms are a condition of maintaining authorized retailer status with UCARI.
      </p>

      <hr />

      <h2>Authorized sales channels</h2>
      <p>
        UCARI products may only be sold through your approved brick-and-mortar retail location(s)
        and/or your owned and operated business website.
      </p>

      <p class="uk-margin-small-top">
        Resale on third-party marketplaces is strictly prohibited, including but not limited to:
      </p>

      <ul class="uk-list uk-list-bullet">
        <li>Amazon</li>
        <li>Walmart Marketplace</li>
        <li>Chewy</li>
        <li>eBay</li>
        <li>Groupon</li>
        <li>Any other online marketplace or reseller platform not expressly approved in writing by UCARI</li>
      </ul>

      <hr />

      <h2>Minimum advertised price (MAP) policy</h2>
      <ul class="uk-list uk-list-bullet">
        <li>
          You agree to comply with UCARI’s Minimum Advertised Price (MAP) of
          <strong>$89.99 per kit</strong>.
        </li>
        <li>
          Temporary price adjustments are permitted only to match Amazon promotional pricing
          when Amazon independently discounts UCARI products.
        </li>
        <li>
          Any such price adjustment must be temporary and must return to the MAP price of
          <strong>$89.99</strong> once Amazon’s pricing returns to MAP.
        </li>
        <li>
          Permanent discounting, undercutting, or failure to restore MAP pricing is not permitted.
        </li>
      </ul>

      <hr />

      <h2>Enforcement</h2>
      <p>
        Failure to comply with these terms may result in one or more of the following actions:
      </p>

      <ul class="uk-list uk-list-bullet">
        <li>Suspension or termination of wholesale purchasing privileges</li>
        <li>Order cancellation</li>
        <li>Loss of authorized retailer status</li>
      </ul>

      <hr />

      <p class="uk-margin-medium-top">
        By clicking <strong>“I Agree”</strong> during login or checkout, you confirm that you have read,
        understand, and agree to comply with these terms as a condition of doing business with UCARI.
      </p>

      <div class="uk-margin-large-top uk-flex uk-flex-right">
        <router-link
          :to="{ name: 'LoginUser' }"
          class="uk-button uk-button-default"
        >
          Back to Login
        </router-link>
      </div>

    </article>
    </main>
    <RetailerFooter />
  </div>
</template>

<script>
import RetailerHeader from './components/RetailerHeader.vue';
import RetailerFooter from './components/RetailerFooter.vue';
import PortalPageHeader from './components/PortalPageHeader.vue';

export default {
  name: 'RetailTerms',
  components: {
    RetailerHeader,
    RetailerFooter,
    PortalPageHeader,
  },
  data() {
    return {
      lastUpdated: 'March 2026'
    };
  }
};
</script>

<style scoped>
.uk-card {
  border-radius: 10px;
}

h2 {
  font-weight: 600;
}

h4 {
  margin-top: 0;
  font-weight: 600;
}
</style>
